import validation from './validation.json';

const locale = {
  ...validation,
};

export default locale;
